import * as yup from 'yup';
import {TaskFormField} from '../../../../../types';
import {TaskField} from '../../../../../../../constants/tasks';
import {validationErrors} from '../../../../../../../constants/constants';

const getStuckItemsSchema = () => yup.array().of(yup.string())
    .required(validationErrors.required)
    .min(1, validationErrors.required);

const getSentimentSliderSchema = () =>
  yup.string().required(validationErrors.required).nullable();

const getValidationSchemaByType = (type: TaskField) => {
  switch (type) {
    case TaskField.EMPLOYEE_STUCKS_CHECKLIST:
      return getStuckItemsSchema();
    case TaskField.SENTIMENT_SLIDER:
      return getSentimentSliderSchema();
    default:
      return yup.object().nullable();
  }
};

export const getValidationSchema = (questions: Nullable<TaskFormField[]>) => {
  if (!questions?.length) {
    return yup.object().nullable();
  }

  return yup.object().shape({
    ...questions?.reduce((acc, {id, type}) => {
      acc[id] = getValidationSchemaByType(type);

      return acc;
    }, {})
  });
};
